import $ from 'jquery';

const PageConfigurationError = () => {
  return (
    <div className="bg-white min-h-full px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8">
      <div className="max-w-max mx-auto">
        <main className="sm:flex">
          <p className="text-4xl font-extrabold text-activecourse-blue sm:text-5xl">
            500
          </p>
          <div className="sm:ml-6">
            <div className="sm:border-l sm:border-gray-200 sm:pl-6">
              <h1 className="text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl">
                Page Configuration Error
              </h1>
              <p className="mt-1 text-base text-gray-500">
                Sorry, we cannot serve this page at this time.
              </p>
            </div>
            <div className="mt-10 flex space-x-3 sm:border-l sm:border-transparent sm:pl-6">
              <a
                href="/"
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-button-text bg-button-bg hover:bg-button-bg-hover hover:text-button-text-hover">
                Go back home
              </a>
              <a
                href="#"
                onClick={() => $('#crispChatOpener').click()}
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-button-text bg-button-bg hover:bg-button-bg-hover hover:text-button-text-hover">
                Contact support
              </a>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default PageConfigurationError;
